export var panelHeight = 60;

export var panelRight = {
    comments: 0,
    slice: 111,
    lighting: 160,
    measure: 205,
    measurePlus: 352,
    info: 253,
    infoPlus: 352,
    tools: 0,
};

export const MAX_CATEGORY_HIT = 4;

export const Errors = {
    ERROR_ADD_OBJECT: "Error Adding Object",
    ERROR_SNAPSHOT: "There is no layer visible, please show a layer before taking a snapshot.",
    ERROR_SERVER: "Error connecting to server. Your credentials may have expired.",
    ENTITY_NOT_FOUND: "Entity not found",
};

export const defaultProject = "all";
export const defaultProjectName = "All";
export { default as Logo } from "assets/branding/voxel-space-logo-white.png";
export { default as LogoHide } from "assets/branding/voxel-space-blue-logo.png";
